import { apiGetMe } from '../../common/api/profile'
import {
  apiCopyAssessmentFile,
  apiArchiveAssessmentFile
} from '../../common/api/assessment'

const fetchMyFiles = (params = {}) => ({
  requestPrefix: 'MY_FILES:FETCH',
  request: () =>
    apiGetMe({
      include: `account.teacher_type.assessment_files,account.teacher_type.assessment_file.details,account.teacher_type.assessment_file.timestamps,account.teacher_type.assessment_file.student_types,account.teacher_type.assessment_file.student_type.account,account.teacher_type.assessment_file.student_type.account.names,account.teacher_type.assessment_file.contributions,account.teacher_type.assessment_file.contributors,account.teacher_type.assessment_file.contributor,account.teacher_type.assessment_file.account.names,account.teacher_type.assessment_file.account.avatar,account.teacher_type.assessment_file.works,account.teacher_type.assessment_file.work.media,account.teacher_type.assessment_file.work.medium.thumb,account.teacher_type.assessment_file.student_type.year_group,account.teacher_type.assessment_file.student_type.year_group.names,account.teacher_type.assessment_file.student_type.year_group.order,account.teacher_type.assessment_files.limit.10,account.teacher_type.assessment_files.page.${params.page ||
        1},account.teacher_type.assessment_files.order.desc`
    })
})

const copyMyFile = id => ({
  requestPrefix: 'MY_FILES:COPY',
  request: () =>
    apiCopyAssessmentFile(id, {
      include:
        'assessment_file.details,assessment_file.timestamps,assessment_file.student_type.account,assessment_file.student_type.account.names,assessment_file.contributions,assessment_file.contributors,assessment_file.contributor,assessment_file.account.names,assessment_file.account.avatar,assessment_file.works,assessment_file.policy,assessment_file.close,assessment_file.teacher_types,assessment_file.teacher_type,assessment_file.teacher_type.account,assessment_file.teacher_type.account.names,assessment_file.work.media,assessment_file.work.medium.thumb'
    })
})

const archiveMyFile = id => ({
  requestPrefix: 'MY_FILES:ARCHIVE',
  params: { id },
  request: () => apiArchiveAssessmentFile(id)
})

export { fetchMyFiles, copyMyFile, archiveMyFile }
